import HttpCliente from "../servicios/HttpCliente";


export const actualizarNotificacion = async (payload) => {
    //console.log(payload);
    return await HttpCliente.put("/Notificaciones/", payload);
};

export const obtenerNotificacion = async (payload) => {
    return await HttpCliente.get(`/Notificaciones/${payload}`);
};